import { usePolicyOnDashboard } from '@folio/utils/usePolicyOnDashboard';
import { HomeIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { useAssertedParams } from '@folio/lib';
import { getPolicyBranchPath } from '@folio/utils/branchDisplayName';
import { Button } from '../ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '../ui/tooltip/tooltip';

export function HomeBranchButton() {
  const { t } = useTranslation();
  const { branchId } = useAssertedParams();
  const location = useLocation();
  const { policy, workingBranch } = usePolicyOnDashboard();

  const isVisible = workingBranch && workingBranch.branchType === 'MTA';

  if (!isVisible) {
    return null;
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Link
          to={getPolicyBranchPath({ policyId: policy.id, currentBranchId: branchId, ...location })}
        >
          <Button variant="outline" size="icon">
            <HomeIcon className="h-4 w-4" />
          </Button>
        </Link>
      </TooltipTrigger>
      <TooltipContent>{t('mtaBanner.viewActiveVersion')}</TooltipContent>
    </Tooltip>
  );
}
